import styled from "styled-components";
import { footer } from "../../../../../ui/_themes/constants/desktop";
import {
  getBackgroundColor,
  getColor
} from "../../../../../ui/_themes/helpers";

export const Wrapper = styled.div`
  pointer-events: all;
  display: ${props => (props.hidden ? "none" : "flex")};
  position: relative;
  padding: 0 1.1em;
  height: ${footer.height};
  color: ${getColor("footer")};
  background: ${getBackgroundColor("footer")};
  justify-content: space-between;
  user-select: none;

  > * {
    font-size: 0.6em;
    font-weight: 700;
    padding-top: 0.25em;
  }
`;
